export const DEFAULT_V2_IMAGE_PATH = '../../../../../images/icons';
